export const getParentPathname = (pathname: string) => {
  return '/' + pathname.split('/')[1]
}
